<template>
        <div>
            <b-row>
                <b-col cols="12" md="6">
                    <app-autocomplete
                        :items="cities"
                        placeholder="Ciudad"
                        v-model="selectedCity"
                    ></app-autocomplete>
                </b-col>
            </b-row>
            <b-row v-if="!!selectedCity">
                <b-col cols="12" class="text-center">
                    <h3>Indicadores de adopción {{ selectedCity.name }}</h3>
                </b-col>
            </b-row>
            <b-row wrap v-if="showCharts">
                <b-col cols="12">
                    <app-operational-charts
                        :pedestrian="charts.pedestrian"
                        :vehicular="charts.vehicular"
                        :annotations="charts.annotations"
                        :mails="charts.mails"
                    ></app-operational-charts>
                </b-col>
            </b-row>
            <b-row wrap v-for="(period, i) in periods" :key="i" class="mb-4">
                <b-col cols="12">
                    <h4>Periodo {{ humanPeriod(period) }}</h4>
                </b-col>
                <b-col cols="12" lg="3" v-if="!!indicators" v-for="(field, j) in fields" :key="j" class="my-2">
                    <app-operational-indicator
                        :total="getIndicator(period).structures"
                        :indicator-data="getIndicator(period)[field.key]"
                        total-label="Estructuras"
                        :value-label="field.label"
                        :icon="field.icon"
                        :period="period"
                    />
                </b-col>
            </b-row>
        </div>
    </template>
    <script>
    import reportingRepository from '../../../../../repositories/reporting.repository';
    import OperationalIndicator from '../../../../UI/Reports/OperationalIndicator';
    import { mapGetters } from 'vuex';
    import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete';
    import * as actionTypes from '../../../../../store/actionTypes';
    import OperationalCharts from '../OperationalCharts/OperationalCharts';
    
    export default {
        name: 'city_operational_indicators',
        components: {
            appOperationalIndicator: OperationalIndicator,
            appAutocomplete: Autocomplete,
            appOperationalCharts: OperationalCharts
        },
        data: () => ({
            selectedCity: '',
            indicators: '',
            periods: [],
            fields: [
                {
                    key: 'pedestrian',
                    label: 'Ingresos Peatonales',
                    icon: 'fa fa-male'
                },
                {
                    key: 'vehicular',
                    label: 'Ingresos Vehiculares',
                    icon: 'fa fa-car'
                },
                {
                    key: 'annotations',
                    label: 'Minutas',
                    icon: 'fa fa-book'
                },
                {
                    key: 'mails',
                    label: 'Correspondencia',
                    icon: 'fa fa-envelope'
                },
            ],
            charts: {
                pedestrian: [],
                vehicular: [],
                annotations: [],
                mails: [],
            },
            showCharts: false
        }),
        watch: {
            selectedCity(val) {
                this.loadIndicators();
            }
        },
        computed: {
            ...mapGetters(['months', 'cities'])
        },
        methods: {
            async loadIndicators() {
                try {
                    const rr = {...reportingRepository};
                    const {data} = await rr.getOperationalIndicatorsByCity(this.selectedCity.id);
                    const periods = {};

                    data.pedestrian.map(item => periods[item.period] = 1);
                    data.vehicular.map(item => periods[item.period] = 1);
                    data.annotations.map(item => periods[item.period] = 1);
                    data.mails.map(item => periods[item.period] = 1);

                    const thePeriods = Object.keys(periods);
                    thePeriods.sort();

                    const indicators = [];

                    let countStructures = 0;

                    thePeriods.map((period, i) => {
                        const structures = data.structures.find(item => item.period === period);
                        const pedestrian = data.pedestrian.find(item => item.period === period);
                        const vehicular = data.vehicular.find(item => item.period === period);
                        const annotations = data.annotations.find(item => item.period === period);
                        const mails = data.mails.find(item => item.period === period);

                        countStructures += structures? structures.total: 0;

                        const pedestrianValue = pedestrian? pedestrian.total: 0;
                        const vehicularValue = vehicular? vehicular.total: 0;
                        const annotationsValue = annotations? annotations.total: 0;
                        const mailsValue = mails? mails.total: 0;

                        const pedestrianIndicator = pedestrianValue / countStructures;
                        const vehicularIndicator = vehicularValue / countStructures;
                        const annotationsIndicator = annotationsValue / countStructures;
                        const mailsIndicator = mailsValue / countStructures;

                        const newIndicator = {
                            structures: countStructures,
                            pedestrian: {
                                value: pedestrianValue,
                                indicator: pedestrianIndicator,
                                status: (0 === i || indicators[i - 1].pedestrian.indicator < pedestrianIndicator) && pedestrianIndicator
                            },
                            vehicular: {
                                value: vehicularValue,
                                indicator: vehicularIndicator,
                                status: (0 === i || indicators[i - 1].vehicular.indicator < vehicularIndicator) && vehicularIndicator
                            },
                            annotations: {
                                value: annotationsValue,
                                indicator: annotationsIndicator,
                                status: (0 === i || indicators[i - 1].annotations.indicator < annotationsIndicator) && annotationsIndicator
                            },
                            mails: {
                                value: mailsValue,
                                indicator: mailsIndicator,
                                status: (0 === i || indicators[i - 1].mails.indicator < mailsIndicator) && mailsIndicator
                            },
                            period
                        }



                        indicators.push(newIndicator);
                    });

                    this.processChartsData(indicators);

                    thePeriods.sort();
                    thePeriods.reverse();
    
                    this.periods = thePeriods;
    
                    this.indicators = indicators;
                }catch(err) {
                    toastr.error(`Ocurrió un error al cargar los indicadores de operación [${err.message}]`)
                }
                
            },
            getIndicator(period) {
                return this.indicators.find(item => item.period === period);
            },
            humanPeriod(period) {
                if(!period.length === 6) return period;
    
                const year = period.substring(0, 4);
                const month = parseInt(period.substring(4));
    
                const theMonth = this.months.find(item => item.id === month);
    
                return `${theMonth.name} de ${year}`;
            },
            processChartsData(indicators) {
                const pedestrian = [['Periodo', 'Indicador']];
                const vehicular = [['Periodo', 'Indicador']];
                const annotations = [['Periodo', 'Indicador']];
                const mails = [['Periodo', 'Indicador']];

                indicators.map(item => {
                    pedestrian.push([item.period, item.pedestrian.indicator]);
                    vehicular.push([item.period, item.vehicular.indicator]);
                    annotations.push([item.period, item.annotations.indicator]);
                    mails.push([item.period, item.mails.indicator]);
                });

                this.charts.pedestrian = pedestrian;
                this.charts.vehicular = vehicular;
                this.charts.annotations = annotations;
                this.charts.mails = mails;

                this.showCharts = true;
            }
        },
        created() {
            this.load('cities');
            this.load('months');
        },
        beforeDestroy() {
            //this.$bus.$off('operational-general-indicators.load');
        }
    
    }
    </script>